import { useNotifications } from "Services/notifications";

import { useMonitorActiveConversations } from "./hooks/useMonitorActiveConversations/useMonitorActiveConversations";

export function UserNotifier(): JSX.Element {
    useMonitorActiveConversations();
    useNotifications();
    return <></>;
}
